import ControlInsertDeleteList from '../view/components/Tablas/ControlCapacitaciones/RelacionDocentes';
import withCtrInsertDocentes from '../hoc/withCtrlInsertDocentes';

export default withCtrInsertDocentes(ControlInsertDeleteList);